import { clientId } from "./client-id";

const DB_NAME = "pptdeep:file-handoff:v1";
const STORE_NAME = "files";

interface StoredFileHandoff {
  id: string;
  /** `file` keeps records written by the previous single-file handoff compatible. */
  file?: File;
  files?: File[];
  createdAt: number;
}

export async function createFileHandoff(files: File[]): Promise<string> {
  if (!files.length) throw new Error("没有可暂存的资料文件");
  const id = clientId();
  const db = await openHandoffDb();
  await requestToPromise(db.transaction(STORE_NAME, "readwrite").objectStore(STORE_NAME).put({ id, files, createdAt: Date.now() } satisfies StoredFileHandoff));
  db.close();
  return id;
}

export async function readFileHandoff(id: string): Promise<File[] | undefined> {
  const db = await openHandoffDb();
  const record = await requestToPromise<StoredFileHandoff | undefined>(
    db.transaction(STORE_NAME, "readonly").objectStore(STORE_NAME).get(id),
  );
  db.close();
  if (!record) return undefined;
  if (Array.isArray(record.files)) return record.files;
  return record.file ? [record.file] : [];
}

export async function removeFileHandoff(id: string): Promise<void> {
  const db = await openHandoffDb();
  await requestToPromise(db.transaction(STORE_NAME, "readwrite").objectStore(STORE_NAME).delete(id));
  db.close();
}

function openHandoffDb(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, 1);
    request.onupgradeneeded = () => {
      request.result.createObjectStore(STORE_NAME, { keyPath: "id" });
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error || new Error("文件暂存失败"));
  });
}

function requestToPromise<T = unknown>(request: IDBRequest<T>): Promise<T> {
  return new Promise((resolve, reject) => {
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error || new Error("文件暂存失败"));
  });
}
